/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmResponsesCompact } from "../../funcs/llmResponsesCompact.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CompactResponseRequest$inboundSchema,
};

export const tool$llmResponsesCompact: ToolDefinition<typeof args> = {
  name: "llm-responses-compact",
  description: `Compact a conversation

Creates a compacted summary of the conversation history for a response, reducing context size while preserving key information. Returns a compacted response object.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmResponsesCompact(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
